import { render, staticRenderFns } from "./TicChatPdf.vue?vue&type=template&id=53ee6b9c&scoped=true&"
import script from "./TicChatPdf.vue?vue&type=script&lang=js&"
export * from "./TicChatPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ee6b9c",
  null
  
)

export default component.exports